import { ReferralsTerm } from '@recruitee/http/types';
import { createEntityCollectionStore } from '@recruitee/ngrx';

import { EntityStoreKey } from '../types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<ReferralsTerm>()(
  EntityStoreKey.terms,
);

export {
  actions as TermsActions,
  reducer as termsReducer,
  selectors as termsSelectors,
  namespace as TermsNamespace,
};
